import { render } from "./BookPackage.vue?vue&type=template&id=3166e02f"
import script from "./BookPackage.vue?vue&type=script&lang=js"
export * from "./BookPackage.vue?vue&type=script&lang=js"

import "./BookPackage.vue?vue&type=style&index=0&id=3166e02f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__